import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';
import {
  Container,
  Column,
  Row,
} from 'styled-components-reactive-grid';
import { px2rem } from 'decisiv-ui-utils';

import TextDiv from 'elements/TextDiv';

import messages from './messages';

function NoNotes({ requesting }) {
  const message = requesting ? 'loadingNotes' : 'noNotesYet';

  return (
    <Container>
      <Row modifiers={['middle']} style={{ height: px2rem(100) }}>
        <Column modifiers={['col', 'center']}>
          <TextDiv modifiers={['midGreyText', 'smallText']}>
            <Trans id={messages[message]} />
          </TextDiv>
        </Column>
      </Row>
    </Container>
  );
}

NoNotes.propTypes = {
  requesting: PropTypes.bool.isRequired,
};

export default NoNotes;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/NoNotes.js